import React from "react";

export default function PrivacyPage() {
  return (
    <div style={{ padding: "40px", maxWidth: "800px", margin: "80px auto 40px", color: "#eee", fontFamily: "Arial, sans-serif", background: "rgba(10, 10, 15, 0.85)", backdropFilter: "blur(10px)", borderRadius: "12px", border: "1px solid #333", boxShadow: "0 4px 30px rgba(0, 0, 0, 0.5)" }}>
      <h1 style={{ color: "#0ff", marginBottom: "20px" }}>Politique de Confidentialité</h1>
      <p style={{ color: "#aaa", fontSize: "0.9rem" }}>Dernière mise à jour : {new Date().toLocaleDateString()}</p>

      <section style={{ marginTop: "30px" }}>
        <h2 style={{ color: "#fff" }}>1. Introduction</h2>
        <p>
          Bienvenue sur notre application. Nous accordons une grande importance à la protection de vos données personnelles.
          Cette politique de confidentialité explique quelles informations nous collectons et comment nous les utilisons.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <h2 style={{ color: "#fff" }}>2. Architecture Non-Custodial (Zero Knowledge)</h2>
        <p style={{ fontWeight: "bold", color: "#ffd700" }}>
          IMPORTANT : Cette application fonctionne sur un modèle "Non-Custodial".
        </p>
        <p>
          Cela signifie que nous ne stockons <strong>JAMAIS</strong> vos clés privées, vos phrases de récupération (seed phrases) ou les tokens générés sur nos serveurs.
          Toute génération de cryptographie se fait localement ou via des canaux éphémères sécurisés, et aucune copie n'est conservée par nos soins.
        </p>
        <p>
          Vous êtes le seul et unique détenteur de vos actifs et informations sensibles. En cas de perte de vos clés ou tokens, nous serons dans l'incapacité technique de les récupérer.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <h2 style={{ color: "#fff" }}>3. Données collectées (Authentification)</h2>
        <p>
          Dans le cadre strict de l'authentification via Google (Google Auth), nous collectons uniquement :
        </p>
        <ul style={{ paddingLeft: "20px", color: "#ccc" }}>
          <li>Votre adresse email</li>
          <li>Votre nom complet</li>
          <li>Votre photo de profil (si disponible)</li>
        </ul>
        <p>
          Ces données servent uniquement à gérer votre session utilisateur et sécuriser l'accès aux tableaux de bord.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <h2 style={{ color: "#fff" }}>4. Vos droits</h2>
        <p>
          Conformément au RGPD, vous disposez d'un droit d'accès, de modification et de suppression de vos données de profil.
          Concernant les données cryptographiques (tokens, clés), celles-ci n'étant pas stockées chez nous, nous ne pouvons pas intervenir dessus.
        </p>
      </section>
    </div>
  );
}
